import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const columns = (navigateTo, showModal) => [
    {
        title: "Nom de la spécialité",
        dataIndex: "name",
        key: "name",
    },
    {
        title: "Abreviation",
        dataIndex: "abreviation",
        key: "abreviation",
    },
    {
        title: "Action",
        key: "action",
        render: (record) => (
            <>
                <Button type="link" className="darkbtn"
                    onClick={() => navigateTo(`edit/spécialité/${record.id}`)}
                >
                    <EditOutlined /> Modifier
                </Button>
                <Button type="link" danger onClick={() => showModal(record.id)}>
                    <DeleteOutlined /> Supprimer
                </Button>
            </>
        ),
    },
];
